/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
 
 import Globals from "../../shared/Globals";
import { qreq } from "../../shared/qrequest";
import AppActions from "../AppActions";
import BaseCom from "../BaseCom";
import Card from "../Card";
import DiagCodeSelect from "../DiagCodeSelect";
import FormInput from "../FormInput";
import Icon from "../Icon";
import InsuranceList from "../InsuranceList";
import LoadingAlert from "../LoadingAlert";
import Patient from "../Patient";
import { withParamsAndNavigate } from "../WithParamsAndNavigate";
import CollectionInfo from "./CollectionInfo";
import PanelSelect from "./PanelSelect";

class SpecimenEdit extends BaseCom {
    constructor(props) {
        super(props);
        this.state = {
            item: {
                patient: null
            },
            specimen: {
                panels: []
            },
            accounts: []
        }
    }

    async componentDidMount() {
        await this.getSettings();
        this.fillList('/api/account/list', 'accounts');

        if(this.props.params.id) {
            try {
                let j = await qreq.getAsync('/api/specimen/get/' + this.props.params.id);
                if (j.item) {
                    this.setState({ specimen: {...j.item, collectedTime: Globals.getTimeOnly(Globals.toISODateString(j.item.collectedDate))}, item: j.item.order });
                }
                else
                    this.alert(j.errorMessage);
            }
            catch {
                this.unkownErrorCallback();
            }
        }
        this.setState({ loaded: true });
    }

    change = () => {
        this.setState({ item: { ...this.state.item }, specimen: { ...this.state.specimen } });
    }

    newPatient = () => {
        this.setState({ item: { ...this.state.item, patient: {}, insurances: [] } });
    }

    selectPatient = async (patient) => {
        if (!patient) {
            this.setState({ item: { ...this.state.item, patient: null, patientID: 0 } });
            return;
        }
        try {
            let j = await qreq.getAsync('/api/patient/get/' + patient.id);
            let item = {...this.state.item};
            if(j.item) {
                item.patient = j.item;
                item.patientID = j.item.id;
                item.insurances = [];

                j = await qreq.getAsync('/api/order/patient/' + patient.id);
                if (j.errorCode === 0) {
                    item.insurances = j.item.insurances;
                    this.setState({ item: item });
                }
                else
                    this.alert(j.errorMessage);
            }
            else
                this.alert(j.errorMessage);
        }
        catch(e) {
            this.unkownErrorCallback();
        }
    }

    mergeDateTime(date, time) {
        if(date.indexOf('T') >= 0)
            date = date.split('T')[0];
        else if(date.indexOf(' ') >= 0)
            date = date.split(' ')[0];
        let str = (date + ' ' + time).replace('Z','');
        return Globals.toISODateString(new Date(str));
    }

    submit = async (e) => {
        e?.preventDefault();
        if (!this.state.item.accountID) {
            this.alert('Please select an account');
            return;
        }
        if (!this.state.item.patient) {
            this.alert('Please select a patient');
            return;
        }
        if(this.state.specimen.panels.length === 0) {
            this.alert('Please select a panel');
            return;
        }
        
        try
        {
            let collectedDateStr = this.state.specimen.collectedDateStr;
            if(!collectedDateStr)
                collectedDateStr = Globals.toISODateString(new Date());
            let data = {
                ...this.state.specimen,
                order: {...this.state.item},
                collectedDate: this.state.specimen.isCollected ? this.mergeDateTime(collectedDateStr, this.state.specimen.collectedTime) : new Date()
            };
            let j = await qreq.postAsync('/api/specimen/save', data);

            if (j.errorCode === 0) {
                this.success('Specimen saved');
                this.goBack();
            }
            else
                this.alert(j.errorMessage);

        }
        catch (e)
        {
            this.alert(e);
            return;
        }
    }

    render() {
        if(!this.state.loaded)
            return <LoadingAlert />
        return <div className="container-fluid vh-expand">
            <form onSubmit={this.submit}>
                <h1>{this.T('specimen')}</h1>
                <Card title="Requisition">
                    <FormInput model={this.state.item} name="accountID" label="Account" type="select" options={this.state.accounts} onChange={this.change} />
                </Card>
                {this.state.item.accountID && <>
                    {!this.state.item.patient && <Card title={this.T('subject')}>
                        <div className="row align-items-center">
                            <div className="col-md-6">
                                <FormInput model={this.state.item} name="patientID" label={this.T('subject')} type="search" searchUrl="/api/patient/list?includeLeads=true" onChange={this.selectPatient} required />
                            </div>
                            <div className="col-md-1 text-center">
                                <div className="p-2">OR</div>
                            </div>
                            <div className="col-md text-center text-md-start">
                                <button type="button" className="btn btn-primary mt-3" onClick={this.newPatient}><Icon icon="faPlus" /> New {this.T('subject')}</button>
                            </div>
                        </div>
                    </Card>}
                    {this.state.item.patient && <>
                        <Card><button type="button" className="btn btn-secondary" onClick={() => this.setState({ item: {...this.state.item, patient: null, patientID: 0 }})}>Change {this.T('subject')}</button></Card>
                        <Patient title={this.T('subject')} item={this.state.item.patient} requestAddress requestContact />
                        <InsuranceList list={this.state.item.insurances} edit />
                        <PanelSelect item={this.state.specimen} onChange={this.change} />
                        <CollectionInfo item={this.state.specimen} onChange={this.change} />
                        <Card title="Collection Notes">
                            <FormInput model={this.state.item} name="collectionNotes" label="Collection Notes" type="textarea" onChange={this.change} />
                        </Card>
                        <DiagCodeSelect item={this.state.specimen} onChange={this.change} />
                    </>}
                </>}

                <AppActions>
                    <button type="submit" className="btn btn-primary btn-lg"><Icon icon="faSave" /> Save</button>
                </AppActions>
            </form>
        </div>;
    }
}

export default withParamsAndNavigate(SpecimenEdit);